<template>
  <div class="container">
    <table-view
      ref="tableList"
      tableCardTitle="LIST"
      :isTableLoading="isTableLoading"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @pageChange="pageChange"
      @searchChange="handleSearchChange"
      :right-btn-options="{ text: 'Add New Request', isHavePermission: true }"
      @changeTitleActionBtn="handleAddCustomer"
    >
      <!--       v-if="tableRow.row.status !== 1 && tableRow.row.status !== 2"   for bpmId show status-->
      <template v-slot:bpmId="{ tableRow }">
        <a href="javascript:void(0)" @click="handleHrefInfoPage(tableRow.row)">
          {{ tableRow.row.bpmId }}
        </a>
      </template>
      <template v-slot:customerType="{ tableRow }">
        {{
          tableRow.row.customerType === 1
            ? 'Trade'
            : tableRow.row.customerType === 2
            ? 'Eaas'
            : 'Saas'
        }}
      </template>
      <template v-slot:fileName="{ tableRow }">
        <a href="javascript:void(0)" @click="handleDownload(tableRow.row.id)">
          {{ tableRow.row.fileName }}
        </a>
      </template>
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void(0)"
          @click="handleHrefSubmit(tableRow.row)"
          v-if="tableRow.row.status === 1"
        >
          Submit
        </a>
      </template>
    </table-view>
    <el-dialog
      title="Add New Request"
      :visible.sync="showAdd"
      width="500px"
      :before-close="handleBeforeClose"
    >
      <el-card shadow="never">
        <div>
          <el-form ref="addForm" :model="addForm" label-width="120px">
            <el-form-item label="customerType" v-if="$store.state.source === 2">
              <el-select v-model="addForm.customerType">
                <el-option
                  v-for="item in customerTypeList1"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="customerType" v-else>
              <el-select v-model="addForm.customerType">
                <el-option
                  v-for="item in customerTypeList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="eaasType" v-if="addForm.customerType === 2">
              <el-select v-model="addForm.eaasType">
                <el-option
                  v-for="item in eaasTypeList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-upload
            ref="upload"
            :action="uploadUrl"
            :headers="{ Authorization: $store.state.token }"
            :auto-upload="true"
            :show-file-list="true"
            :on-change="handleChange"
            :file-list="fileList"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
            :data="{
              customerType: addForm.customerType,
              eaasType: addForm.customerType === 2 ? addForm.eaasType : '',
            }"
          >
            <customize-button class="upload">Add Attachment</customize-button>
          </el-upload>
        </div>
        <p class="downloadT" @click="handleDownloadTemplate">
          Download Template
        </p>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import { getTableList, downloadFile, downloadTemplate } from './api'
import config from '@/config'
import { ERR_OK } from '@/utils/request'

export default {
  name: 'home',
  data() {
    const searchModel = [
      { label: 'Trans#', type: 'input', key: 'bpmId' },
      { label: 'ID#', type: 'input', key: 'id' },
      {
        label: 'Status',
        type: 'select',
        key: 'status',
        selectList: [
          { id: 1, name: 'Pass' },
          { id: 2, name: 'Failure' },
          { id: 3, name: 'Awaiting Credit Review' },
          { id: 4, name: 'Approved' },
          { id: 5, name: 'Declined' },
        ],
      },
    ]
    const tableModel = [
      { slotName: 'bpmId', label: 'Trans#' },
      { prop: 'id', label: 'ID' },
      {
        prop: 'partialcreditlimits',
        label: 'Partial credit limits',
        width: '150px',
      },
      { prop: 'typeStr', label: 'Category' },
      { prop: 'total', label: 'Quantity' },
      { prop: 'createTime', label: 'Create Time' },
      { prop: 'operator', label: 'Submitted By' },
      { prop: 'approver', label: 'Assigned To' },
      { slotName: 'fileName', label: 'Doc.' },
      { slotName: 'customerType', label: 'Customer Type' },
      { prop: 'statusStr', label: 'Status' },
      { slotName: 'action', label: 'Action' },
    ]
    return {
      uploadUrl: `${config.baseApi}/workflow-api/credit-batch/upload`,
      searchModel,
      tableModel,
      tableData: [],
      isTableLoading: true,
      pages: {},
      showAdd: false,
      fileList: [],
      customerTypeList: [
        {
          id: 1,
          name: 'Trade',
        },
        {
          id: 2,
          name: 'Eaas',
        },
        {
          id: 3,
          name: 'Saas',
        },
      ],
      customerTypeList1: [
        {
          id: 4,
          name: 'CSS',
        },
      ],
      eaasTypeList: [
        {
          id: 1,
          name: 'CAPEX',
        },
        {
          id: 2,
          name: 'OPEX',
        },
      ],
      addForm: {
        customerType: '',
        eaasType: '',
      },
    }
  },
  mounted() {
    this.initTable()
  },
  methods: {
    handleBeforeClose(done) {
      this.addForm.customerType = ''
      this.addForm.eaasType = ''
      this.fileList = []
      done()
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableList(params)
    },
    async _getTableList(params) {
      this.isTableLoading = true
      try {
        const { data, page } = await getTableList(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.err(err)
      }
      this.isTableLoading = false
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableList(params)
    },
    pageChange(curPage) {
      const queryForm = {}
      const params = Object.assign({}, queryForm, {
        current: curPage.current,
        size: 10,
        status: curPage.status,
      })
      this._getTableList(params)
    },
    handleHrefInfoPage(row) {
      // trans#: use bpmId
      let routeUrl = this.$router.resolve({
        name: 'batchAuditDetail',
        path: '/credit-management/credit-batch-request/audit-detail',
        query: {
          bpmId: row.bpmId,
          id: row.id,
          fileName: row.fileName,
          typeStr: row.typeStr,
          total: row.total,
        },
      })
      window.open(routeUrl.href, '_blank')
    },
    handleHrefSubmit(row) {
      this.$router.push({
        name: 'batchSubmitDetail',
        path: '/credit-management/credit-batch-request/detail',
        query: {
          id: row.id,
        },
        params: {
          ...row,
        },
      })
    },
    async handleDownload(id) {
      try {
        await downloadFile(id)
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
    handleAddCustomer() {
      this.showAdd = true
    },
    handleChange(file) {
      if (!file.response) {
        this.fileList.splice(0, 1, file)
      }
    },
    beforeUpload(file) {
      const fileFormat = file.name.substring(file.name.lastIndexOf('.') + 1)
      const correctFormat = 'xlsx'
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!');
      // }

      if (this.addForm.customerType === '') {
        this.$message.error('Please select customerType')
        this.fileList = []
        return false
      }

      if (this.addForm.customerType === 2 && this.addForm.eaasType === '') {
        this.$message.error('Please select eaasType!')
        this.fileList = []
        return false
      }

      if (fileFormat !== correctFormat) {
        this.$message.error('Upload file can only be .xlsx format!')
        return false
      }
      return true
    },
    handleUploadSuccess({ code, msg }) {
      if (code === ERR_OK) {
        this.$message.success('success')
        this.initTable()
        this.showAdd = false
        this.fileList = []
      } else {
        this.$message.error(msg)
        this.fileList.pop()
      }
    },
    async handleDownloadTemplate() {
      try {
        await downloadTemplate()
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style scoped lang="less">
.container {
  .downloadT {
    text-align: right;
    cursor: pointer;
    color: #4458fe;
    margin-top: 24px;
  }
}
</style>
